import { getPocketBase, escFilter as esc } from '../pocketbase.js';

export async function fetchStudioTargets(accessKey, pbOverride) {
  const pb = pbOverride || getPocketBase();
  return pb.collection('studio_targets').getFullList({
    filter: `access_key="${esc(accessKey)}"`,
  });
}

export async function upsertStudioTarget({ accessKey, playerKey, maxPrice, notes, sold, band, labels, backups, missing, sortOrder }, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const data = {
    access_key: accessKey,
    player_key: playerKey,
    max_price: maxPrice,
    notes: notes || '',
    sold: !!sold,
    band: band || '1',
    labels: labels || [],
    backups: backups || [],
    missing: !!missing,
    sort_order: Number.isFinite(Number(sortOrder)) ? Number(sortOrder) : 0,
  };
  const existing = await pb.collection('studio_targets').getFullList({
    filter: `access_key="${esc(accessKey)}" && player_key="${esc(playerKey)}"`,
  });
  if (existing.length) return pb.collection('studio_targets').update(existing[0].id, data);
  return pb.collection('studio_targets').create(data);
}

export async function deleteStudioTarget(accessKey, playerKey, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const existing = await pb.collection('studio_targets').getFullList({
    filter: `access_key="${esc(accessKey)}" && player_key="${esc(playerKey)}"`,
  });
  for (const r of existing) await pb.collection('studio_targets').delete(r.id);
  return { deleted: existing.length };
}

export async function fetchStudioBudget(accessKey, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const rows = await pb.collection('studio_settings').getFullList({
    filter: `access_key="${esc(accessKey)}"`,
  });
  if (rows.length && typeof rows[0].budget === 'number') return rows[0].budget;
  return 500;
}

export async function saveStudioBudget(accessKey, budget, pbOverride) {
  const pb = pbOverride || getPocketBase();
  const data = { access_key: accessKey, budget: Number(budget) || 0 };
  const existing = await pb.collection('studio_settings').getFullList({
    filter: `access_key="${esc(accessKey)}"`,
  });
  if (existing.length) return pb.collection('studio_settings').update(existing[0].id, data);
  return pb.collection('studio_settings').create(data);
}
